import { isObject } from '@yembo/yemblocks-core/dist/_util/validateData';

export type ErrorWithResponse = {
  response?: {
    data?: {
      status?: { message: string }[];
    };
  };
  message?: string;
};

const isErrorWithResponse = (error: undefined | string | ErrorWithResponse): error is ErrorWithResponse =>
  !!error && isObject(error);

export const parseErrorMessage = (error: ErrorWithResponse | string): string => {
  let result;

  if (typeof error === 'string') return error;

  if (!isErrorWithResponse(error)) return 'Error';

  if (error.response?.data?.status instanceof Array) {
    const status = error.response.data.status as { message: string }[];
    result = status[0]?.message;
  } else {
    result = error.message;
  }

  return result ?? 'Error';
};
